// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@keyframes circular-animation-baba9168{to{stroke-dashoffset:0}}.qdap-home[data-v-baba9168]{width:100%}#questionnaire[data-v-baba9168]{scroll-margin-top:100px}@media only screen and (max-width:1024px){#questionnaire[data-v-baba9168]{scroll-margin-top:80px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
